import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";
import PhishingGame from "./PhishingGame";

const Chapter2_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welches ist ein typisches Merkmal einer Phishing-Nachricht?",
      options: [
        {
          value: "A",
          label:
            "Die Nachricht erzeugt psychischen Druck, indem sie mit Kontosperrung oder Konsequenzen droht, wenn nicht sofort gehandelt wird.",
        },
        {
          value: "B",
          label:
            "Eine Phishing-E-Mail enthält niemals einen Anhang, immer nur einen Link.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wofür steht der Begriff Business Email Compromise (BEC)?",
      options: [
        {
          value: "A",
          label:
            "BEC bezeichnet eine Betrugsmethode, bei der Angreifer geschäftliche E-Mail-Konten kompromittieren, um vertrauliche Informationen zu stehlen oder Geldtransfers zu erwirken.",
        },
        {
          value: "B",
          label:
            "BEC ist eine Technik, bei der Unternehmen ihre E-Mails verschlüsseln, um die Kommunikation sicherer zu machen.",
        },
      ],
      correct: "A",
    },
  ];

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 2_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 
        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "2_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("2_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 2_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "2_4",
              completedChapters: ["2_4"],
            });
          console.log("Dokument erstellt mit Kapitel 2_4.");
        }

        navigate("/2_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  2: Sicherheitslücken und Schwachstellen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Phishing
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 2: Sicherheitslücken und Schwachstellen
          </h3>
          <h2 className="text-center p-3">Phishing</h2>
          <img
            src="./images/fischen.webp"
            alt="Transparent"
            style={{ position: "relative", maxWidth: "60%", height: "auto" }}
          />
        </div>
        <div className="p-5 text-center">
          <h2 className="p-5">
            Phishing – Techniken, Ziele und Abwehrstrategien
          </h2>
          <p className="col-lg-11 mx-auto">
            Phishing ist eine weitere besondere Schwachstelle. Es resultiert
            aus einer Lücke im Sicherheitsbewusstsein und dem Verhalten von Nutzern.
          Angreifer umgehen technische Sicherheitsmaßnahmen wie
            Firewalls oder Verschlüsselung, indem sie direkt die Benutzer
            "angreifen". Der Begriff leitet sich vom englischen Wort "fishing"
            ab und bezieht sich auf das "Angeln" nach vertraulichen
            Informationen, wie z. B. Passwörtern oder Kreditkartennummern.
          </p>
          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Laut eines Kaspersky-Reports von 2024 steht Deutschland bei
            gefährlichen Phishing-E-Mails europaweit auf Platz drei. Insgesamt
            identifizierten die Sicherheitsexperten im Jahr 2024 34.281.620
            Phishing-Angriffe auf Nutzer aus Deutschland.
          </p>
          <h3 className="pt-5">Die unterschiedlichen Arten des Phishings:</h3>
          <h4 className="p-5">1. Klassisches Phishing</h4>
          <p className="col-lg-11 mx-auto">
            Klassisches Phishing nutzt E-Mails oder andere Kommunikationsmittel.
            Angreifer erstellen gefälschte Nachrichten, die oft eine
            vermeintlich dringende Handlung erfordern, wie das Klicken auf einen
            Link oder das Eingeben von Anmeldedaten. Diese Nachrichten können
            täuschend echt aussehen und Logos, Farben und Formulierungen von
            bekannten Unternehmen oder Organisationen enthalten.
          </p>
          <p className="col-lg-11 mx-auto">
            <strong>Technische Funktionsweise:</strong> Phishing-E-Mails
            enthalten oft Links zu gefälschten Webseiten, die aussehen wie
            legitime Webseiten (z. B. Banken oder Online-Dienste). Diese
            gefälschten Webseiten sind so gestaltet, dass sie die Opfer zur
            Eingabe ihrer Zugangsdaten oder anderer sensibler Informationen
            verleiten.
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            Ein Benutzer erhält eine E-Mail von "seiner Bank", die ihn
            auffordert, sein Konto aufgrund eines "Sicherheitsproblems" zu
            verifizieren. Der enthaltene Link führt zu einer gefälschten Seite,
            die die Zugangsdaten abfängt.
          </p>{" "}
        </div>{" "}
      </div>

      <div className="gelb-section">
        <div className="container">
          <div className="p-5 text-center">
            <h4 className="p-5">2. Spear Phishing</h4>

            <p className="pb-5 col-lg-11 mx-auto">
              Im Gegensatz zum klassischen Phishing, das breite Zielgruppen
              anspricht, ist Spear Phishing gezielt auf einzelne Personen oder
              Organisationen ausgerichtet. Diese Angriffe sind oft
              personalisiert und nutzen Informationen, die zuvor über das Ziel
              gesammelt wurden.
            </p>
            <p className="col-lg-11 mx-auto">
              <strong>Technische Funktionsweise:</strong> Spear Phishing
              erfordert eine vorherige Informationsbeschaffung, um
              personalisierte Nachrichten zu erstellen. Dies kann durch Social
              Engineering, das Durchsuchen sozialer Medien oder das Ausnutzen
              von Datenlecks geschehen. Die Angreifer senden dann E-Mails, die
              speziell auf die Interessen oder Pflichten des Opfers abgestimmt
              sind.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Der Mitarbeitende einer Firma erhält eine E-Mail von einer
              "Kollegin" mit einer dringenden Bitte um Überprüfung eines
              angehängten Dokuments. Das Dokument enthält jedoch Schadsoftware,
              die beim Öffnen das Unternehmensnetzwerk infiziert.

           <br />Die E-Mail könnte zudem personalisierte Informationen enthalten,
              um vertrauenswürdig zu wirken, wie den Namen des Mitarbeiters, des
              Geschäftsbereichs oder aktueller Projekte, die der Mitarbeiter auf
              LinkedIn oder anderen Plattformen erwähnt hat.</p>
            <p className="pb-5 col-lg-11 mx-auto">
              Zunehmend geben sich die Absender als Führungskräfte aus mit der
              Bitte um Überweisung von gefälschten Rechnungen oder Weitergabe
              von vertraulichen Informationen. Diese{" "}
              <strong>Business Email Compromise (BEC) </strong> basieren auf
              sozialer Manipulation. Da sie keine schädliche Software (Malware)
              benutzen, werden diese Mails schwer von Mailprogrammen erkannt und
              blockiert. Das macht sie sehr gefährlich. BEC macht mittlerweile
              21% aller E-Mail-Angriffe aus (Anstieg um 15%), (PR-Newswire 2024)
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <h4 className="p-5">3. Whaling</h4>

          <p className="pb-5 col-lg-11 mx-auto">
            Whaling ist eine spezielle Form des Spear Phishings, die sich auf
            hochrangige Führungskräfte oder Personen mit Zugang zu sensiblen
            Informationen konzentriert. Diese Angriffe sind oft besonders
            ausgeklügelt und können erheblichen Schaden anrichten, wenn sie
            erfolgreich sind.
          </p>
          <p className="col-lg-11 mx-auto">
            <strong>Technische Funktionsweise:</strong> Whaling-Angriffe nutzen
            detaillierte Informationen über die Zielperson und verwenden oft
            gefälschte Geschäfts-E-Mails oder Dokumente. Diese Nachrichten sind
            darauf ausgelegt, die Zielperson dazu zu bringen, vertrauliche
            Geschäftsinformationen preiszugeben oder finanzielle Transaktionen
            durchzuführen.
          </p>
          <p className="col-lg-9 mx-auto  p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            <br />
            <br />
            Ein Angreifer findet über Linkedin heraus, dass der CFO einer Firma
            gerade auf einer Geschäftsreise ist. Der Angreifer sendet eine
            gefälschte E-Mail an den Finanzleiter oder Buchhalter des
            Unternehmens:
            <br />
            <br /> "Hallo Herr Meier,
            <br />
         
            ich bin gerade auf einer wichtigen Geschäftsreise und benötige
            dringend Ihre Unterstützung. Wir müssen eine vertrauliche Zahlung in
            Höhe von 250.000 EUR an unseren neuen Geschäftspartner in Hongkong
            leisten, um einen wichtigen Vertragsabschluss zu sichern.
            <br />
           
            Die Bankdaten lauten: Empfänger: HK Trading Ltd., IBAN: HK123456789.
            <br />
        
            Ich zähle auf Ihre Diskretion – diese Transaktion ist höchst
            vertraulich und darf nicht intern besprochen werden. Bitte
            bestätigen Sie mir schnellstmöglich die Überweisung.
            <br />
          
            Beste Grüße, [Gefälschter Name des CEOs]"
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container">
          <div className="p-5 text-center">
            <h4 className="p-5">4. Vishing (Voice Phishing)</h4>

            <p className="pb-5 col-lg-11 mx-auto">
              Vishing (Voice Phishing) ist eine Betrugsmasche, bei der Angreifer versuchen, über Telefonanrufe an vertrauliche Informationen zu gelangen. Dabei geben sie sich häufig als Bankmitarbeiter, IT-Support oder Behördenvertreter aus und setzen ihre Opfer unter Druck, etwa mit dem Hinweis auf ein angeblich gehacktes Konto oder eine dringende Sicherheitsprüfung. Ziel ist es, sensible Daten wie Zugangsdaten, TAN-Nummern oder Kreditkarteninformationen zu erlangen. Anders als beim klassischen Phishing per E-Mail wird hier gezielt die persönliche Wirkung der Stimme genutzt, um Vertrauen aufzubauen und schnelle Entscheidungen zu erzwingen.
            </p>
            <p className="col-lg-11 mx-auto">
              Vishing kann sowohl durch echte Personen als auch durch automatisierte oder KI-gestützte Stimmen erfolgen. Dabei wird die Voice-over-IP-Technologie genutzt, um Anrufe zu tätigen und              Nummern zu fälschen, sodass sie glaubwürdig erscheinen. Die
              Angreifer können dabei Sprachmuster verwenden, die Autorität oder
              Dringlichkeit vermitteln, um das Opfer zu beeinflussen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Im Sommer 2023 meldeten mehrere Sparkassen in Deutschland einen Vishing-Betrugsfall, bei dem Anrufer sich als Mitarbeiter der „IT-Sicherheitsabteilung“ ausgaben und bei älteren Kunden mehrfach erfolgreich Online-Banking-Zugangsdaten und TANs abgefragt haben. Die Täter verwendeten dabei gefälschte Telefonnummern, die scheinbar von der echten Bank stammten („Caller ID Spoofing“), und erzählten eine glaubwürdige Geschichte über angebliche „Sicherheitsprobleme im System“, um die Opfer zur Herausgabe ihrer Daten zu bewegen. In mehreren Fällen ergaben sich daraus finanzielle Schäden im vier- bis fünfstelligen Bereich pro Kunde.
            </p>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h2 className="p-5">Ziele und Auswirkungen von Phishing</h2>

            <p className="col-lg-11 mx-auto">
              Phishing hat verschiedene Ziele, die je nach Art des Angriffs und
              den spezifischen Interessen der Angreifer variieren können:
              <br />
              <br />
              <strong>Identitätsdiebstahl:</strong> Angreifer stehlen
              persönliche Informationen, um Identitäten zu übernehmen und
              betrügerische Aktivitäten durchzuführen.
           
             (Aktive Social Media Nutzer haben dabei ein 30-46% höheres
              Risiko für Identitätsdiebstahl!)             <br />
              <br />
              <strong>Finanzbetrug:</strong> Die erlangten Informationen können
              verwendet werden, um Geld zu stehlen oder unerlaubte
              Finanztransaktionen durchzuführen. (Das Bundeskriminalamt registrierte 2023 rund 90.000 Fälle
              von Banking-Betrug. Die tatsächliche Zahl der Betrugsfälle liegt
              vermutlich deutlich höher, da viele Fälle nicht gemeldet werden!)
              <br />
              <br />
              <strong>Zugang zu Netzwerken:</strong> Durch die Erlangung von
              Zugangsdaten können Angreifer sich Zugang zu
              Unternehmensnetzwerken verschaffen, um Daten zu stehlen oder
              weitere Angriffe durchzuführen. (3,4 Milliarden Phishing-Emails werden täglich versendet!)
              <br />
              <br />
              <strong>
                Verbreitung von schädlicher Software (Malware):
              </strong>{" "}
              Phishing kann als Vektor zur Verbreitung von schädlicher Software
              dienen, die Systeme infizieren und Schaden anrichten kann.
              (Über 300.000 Android-Nutzer haben Banking-Trojaner über den
              Google Play Store heruntergeladen (Varonis 2024)!)
            </p>
            <p className="col-lg-11 pt-3 mx-auto">
              Die Auswirkungen von Phishing-Angriffen sind weitreichend. Opfer
              können finanziellen Verlust erleiden, ihre Privatsphäre verlieren
              oder ihren Ruf beschädigen. Unternehmen können durch
              Datenverluste, Betriebsunterbrechungen und den Verlust von
              Kundenvertrauen erhebliche Schäden erleiden. <br />
              <br />
            </p>
            <div className="row">
              {" "}
              <div className="text-start mt-5">
                <PhishingGame />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Phishing mit Künstlicher Intelligenz (KI)</h3>

            <p className="col-lg-11 mx-auto">
             Durch den Einsatz von Künstlicher Intelligenz hat sich Phishing deutlich weiterentwickelt und ist professioneller geworden. KI ermöglicht es Angreifern, in kurzer Zeit große Mengen an glaubwürdig formulierten Nachrichten zu erstellen, die sprachlich korrekt sind und nicht mehr wie typischer Spam wirken. Dadurch werden Phishing-Mails individueller, überzeugender und schwerer zu erkennen.
              <br />
              <br />
             Durch die Nutzung öffentlich zugänglicher Daten
              erstellt sie <strong> personalisierte Angriffe, </strong> bei
              denen Nachrichten spezifische Informationen wie den Namen, den
              Arbeitgeber oder Interessen des Opfers enthalten, um Vertrauen zu
              gewinnen. Mithilfe von <strong> Deepfake-Technologien </strong>{" "}
              können täuschend echte Stimmen oder Videos generiert werden,
              beispielsweise um einen Vorgesetzten nachzuahmen und Überweisungen
              zu erwirken. Zusätzlich nutzt KI{" "}
              <strong> emotionale Manipulation, </strong> indem sie überzeugende
              Texte formuliert, die mit Drohungen, Dringlichkeit oder
              Belohnungen Druck auf das Opfer ausüben.
              <br />
              <br />
              KI kann Anti-Phishing-Technologien umgehen, indem sie die Muster
              und Algorithmen analysiert, die Sicherheitsfilter verwenden.
              Dadurch werden Phishing-Mails so angepasst, dass sie authentisch
              wirken und nicht blockiert werden. Das macht Phishing-Angriffe
              nicht nur effizienter, sondern auch schwerer zu erkennen. Dadurch steigt das Risiko von CEO-Fraud, Zahlungsbetrug und Datendiebstahl deutlich – selbst bei gut geschulten Mitarbeitenden.
            </p>

<p className="col-lg-9 mx-auto  p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            <br />
            <br />
            Anfang 2025 gab es eine Phishing-Welle gegen YouTube-Content-Creatoren, bei der Betrüger ein KI-generiertes Deepfake-Video des YouTube-CEOs Neal Mohan nutzten. Die Nachricht behauptete eine angebliche Änderung der Monetarisierungsregeln und führte die Empfänger zu Fake-Seiten/Downloads, um Login-Daten abzugreifen oder Schadsoftware einzuschleusen. YouTube hat Creators ausdrücklich davor gewarnt und klargestellt, dass solche „CEO-Videos“ in privaten Nachrichten ein typisches Phishing-Muster sind. (theverge 04.03.2025)
          </p>










          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />
          <h3 className="p-5">Prävention und Abwehrstrategien</h3>
          <h4 className="p-3">1. Technische Schutzmaßnahmen</h4>
          <p className="col-lg-11 text-start mx-auto">
            <strong>E-Mail-Filter: </strong> <br />
            E-Mail-Filter analysieren eingehende Nachrichten anhand bestimmter
            Kriterien, wie Schlüsselwörter oder Phrasen (Gewonnen, Dringend),
            eingebetteter Links, künstlich wirkender Texte mit vielen
            Rechtschreibfehler oder Anhänge wie die Dateitypen .zip oder .exe.
            Die bekanntesten Filter sind <strong> Spam-Filter, </strong>die Mails
            auf die Absenderadresse, Betreffzeile, Schlüsselwörter und Anhänge
            überprüft. Dabei werden Technologien wie Blacklist-Prüfungen,
            Heuristik (Regelbasiertes Lernen) und Maschinelles Lernen angewandt,
            um Muster von Spam-Nachrichten zu identifizieren. E-Mails, die als
            verdächtig eingestuft werden, landen entweder im Spam-Ordner oder
            werden blockiert, bevor sie den Empfänger erreichen.
            <br />
            Es gibt auch
            <strong> Regelbasierte Filter. </strong> Hierbei definiert der
            Nutzer selber Regeln um verdächtige Nachrichten zu identifizieren.
            Diese Regeln können bestimmte Kriterien wie Schlüsselwörter (z. B.
            „Gratis“, „Gewinnspiel“), Betreffzeilen, verdächtige
            Absenderadressen, bestimmte Anhang-Typen oder sogar die Häufigkeit
            bestimmter Wörter in einer E-Mail umfassen. Jede erkannte Regel
            vergibt einen Spam-Score (Punktwert), und wenn eine E-Mail einen
            bestimmten Schwellenwert überschreitet, wird sie als Spam markiert.
            <br />
            <br />
            <strong>SPF, DKIM und DMARC: </strong> <br />
            Diese Technologien sorgen dafür, dass überprüft wird, ob eine E-Mail
            wirklich von dem vorgegebenen Absender stammt, der sie vorgibt zu
            sein.
            <br />
            <ul>
              <li>
                SPF (Sender Policy Framework) stellt sicher, dass nur
                autorisierte Mailserver E-Mails im Namen einer bestimmten Domain
                versenden dürfen. Dazu wird in den DNS-Einstellungen der Domain
                festgelegt, welche Server berechtigt sind, E-Mails zu
                verschicken.{" "}
              </li>
              <li>
                DKIM (DomainKeys Identified Mail) geht noch einen Schritt
                weiter, indem es jede E-Mail mit einer digitalen Signatur
                versieht. Diese Signatur wird vom empfangenden Mailserver
                mithilfe eines öffentlichen Schlüssels überprüft, der ebenfalls
                in den DNS-Einträgen der Domain hinterlegt ist. Dadurch wird
                sichergestellt, dass die Nachricht während der Übertragung nicht
                manipuliert wurde und tatsächlich vom angegebenen Absender
                stammt.
              </li>
              <li>
                DMARC (Domain-based Message Authentication, Reporting &
                Conformance) kombiniert SPF und DKIM und gibt an, wie mit
                E-Mails umgegangen werden soll, die diese Prüfungen nicht
                bestehen. Zum Beispiel kann DMARC festlegen, dass solche E-Mails
                direkt gelöscht oder als Spam markiert werden.
              </li>
            </ul>
            <br />
            <strong>Multi-Faktor-Authentifizierung:</strong> <br />
            Die Implementierung von{" "}
            <Link to="/2_3#mfa" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Multi-Faktor-Authentifizierung (MFA)
            </Link>{" "}
            erhöht die Sicherheit erheblich, da Angreifer, selbst wenn sie
            Zugangsdaten erlangen, nicht ohne den zweiten
            Authentifizierungsfaktor auf Konten zugreifen können. <br /> <br />
            <strong>Verschlüsselung:</strong> <br />
            Der Einsatz von Verschlüsselung für sensible Daten und
            Kommunikationskanäle kann verhindern, dass Angreifer im Falle eines
            erfolgreichen Phishing-Angriffs auf diese Informationen zugreifen
            können.
          </p>
          <h4 className="pt-5 pb-3">2. Aufklärungs- und Schulungsmaßnahmen</h4>
          <p className="col-lg-11 text-start mx-auto">
            <Link to="/2_2#saw" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Security Awareness:
            </Link>{" "}
            <br />
            Regelmäßige Schulungen und Sensibilisierungskampagnen sind
            entscheidend, um Benutzer über die Gefahren von Phishing
            aufzuklären. Sie sollten darüber informiert werden, wie sie
            verdächtige Nachrichten erkennen können und darauf hingewiesen
            werden, keine persönlichen Informationen über ungesicherte Kanäle zu
            teilen.
            <br />
            <br />
            <strong>Simulierte Phishing-Übungen:</strong> <br />
            Unternehmen können simulierte Phishing-Angriffe durchführen, um das
            Bewusstsein der Mitarbeiter zu testen und zu verbessern. Diese
            Übungen helfen, Schwachstellen in der Organisation zu identifizieren
            und zu beheben.
            <br />
            <br />
            <strong>Richtlinien und Verfahren:</strong> <br />
            Unternehmen sollten klare Richtlinien und Verfahren implementieren,
            um sicherzustellen, dass Mitarbeiter verdächtige E-Mails oder
            Anfragen korrekt handhaben. Es sollte ein einfacher Prozess
            eingerichtet werden, beispielsweise über ein zentrales
            IT-Support-System oder spezielle Sicherheitsbeauftragte. Diese
            Maßnahmen schaffen Sicherheit im Umgang mit Bedrohungen und fördern
            eine proaktive Reaktion.
          </p>
          <h4 className="p-5">
            3. Incident-Response-Strategie (Reaktion auf Sicherheitsvorfall)
          </h4>
          <p className="col-lg-11 text-start mx-auto">
            Im Fall eines erfolgreichen Phishing-Angriffs ist eine schnelle
            Reaktion entscheidend. Dazu gehören:
            <br />
            <br />
            <strong>Sofortige Sperrung betroffener Konten:</strong>
            <br />
            Sobald ein Angriff erkannt wird, sollten kompromittierte Konten
            unverzüglich gesperrt oder Zugriffsrechte entzogen werden, um
            weiteren Schaden zu verhindern.
            <br />
            <br />
            <strong>Untersuchung und Behebung:</strong> <br />
            Eine gründliche Untersuchung des Vorfalls ist notwendig, um das
            Ausmaß des Schadens zu bestimmen und die Ursache zu identifizieren.
            Betroffene Systeme sollten gesäubert und gesichert werden.
            <br />
            <br />
            <strong>Benachrichtigung und Kommunikation:</strong>
            <br /> Betroffene Personen und gegebenenfalls Behörden wie
            Datenschutzaufsichtsstellen sollten über den Vorfall informiert
            werden. Eine transparente Kommunikation ist wichtig, um Vertrauen zu
            erhalten und potenziellen Schaden zu minimieren.
          </p>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-11 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter2_4;
